// Plays a short upbeat success chime using the Web Audio API.
// No external assets needed; works on iPad Safari after first user gesture.

let audioCtx: AudioContext | null = null;

const getAudioContext = (): AudioContext | null => {
  if (typeof window === 'undefined') return null;
  const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctx) return null;
  if (!audioCtx) {
    audioCtx = new Ctx();
  }
  return audioCtx;
};

export const playSuccessSound = (): void => {
  const ctx = getAudioContext();
  if (!ctx) return;

  // iOS suspends the context until a user gesture; resume on first call.
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }

  const now = ctx.currentTime;
  // Two ascending notes (C5 -> E5 -> G5) for a cheerful major-chord arpeggio.
  const notes = [523.25, 659.25, 783.99];
  const noteDuration = 0.12;

  notes.forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'triangle';
    osc.frequency.value = freq;

    const start = now + i * noteDuration * 0.7;
    const end = start + noteDuration;

    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(0.18, start + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, end);

    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(start);
    osc.stop(end + 0.02);
  });
};
